import React, { FC, ReactNode } from 'react';

import { Box, Typography } from '@material-ui/core';
import cx from 'classnames';
import { Link } from 'react-router-dom';

import ChevronTopIcon from '../../../../assets/icons/ChevronTopIcon';
import useStyles from './styles';

interface CardTitleWithNavProps {
  title: string;
  containerClass?: string;
  wrapperClass?: string;
  titleClass?: string;
  iconClass?: string;
  goBackLink?: string | null;
  subTitle?: string;
  children?: ReactNode;
}

const CardTitleWithNav: FC<CardTitleWithNavProps> = ({
  title,
  containerClass = '',
  wrapperClass = '',
  titleClass = '',
  iconClass = '',
  goBackLink,
  subTitle,
  children,
}) => {
  const classes = useStyles();

  return (
    <Box className={cx(classes.titleContainer, containerClass)}>
      <Box className={cx(classes.titleWrap, wrapperClass)}>
        {goBackLink && (
          <Link to={goBackLink}>
            <ChevronTopIcon className={cx(classes.navIcon, iconClass)} />
          </Link>
        )}
        <div className={classes.title}>
          <Typography
            data-testid="title"
            variant="h3"
            className={cx(classes.cardTitle, titleClass)}
          >
            {title}
          </Typography>
          {subTitle && (
            <Typography data-testid="subTitle" className={cx(classes.cardSubTitle)}>
              {subTitle}
            </Typography>
          )}
        </div>
      </Box>
      {children}
    </Box>
  );
};

export default CardTitleWithNav;
